import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ClinicSearchbarComponent } from './components/clinic-searchbar/clinic-searchbar.component';
import { ClinicListComponent } from './components/clinic-list/clinic-list.component';
import { ClinicItemComponent } from './components/clinic-item/clinic-item.component';
import { IonicModule } from '@ionic/angular';
import { GenericComponent } from './pages/generic/generic.component';
import { PersonalizedComponent } from './pages/personalized/personalized.component';
import { Routes, ROUTES } from '@angular/router';
import { SettingsQuery } from '../../shared/state/settings/settings.query';
import { ContentSkeletonComponent } from './components/content-skeleton/content-skeleton.component';
import { HeaderGenericComponent } from './components/header-generic/header-generic.component';
import { HeaderPersonalizedComponent } from './components/header-personalized/header-personalized.component';
import { ParentSystemkeyGuard } from '../../shared/guards/parent-systemkey.guard';

@NgModule({
    declarations: [
        ClinicSearchbarComponent,
        ClinicListComponent,
        ClinicItemComponent,
        GenericComponent,
        PersonalizedComponent,
        ContentSkeletonComponent,
        HeaderGenericComponent,
        HeaderPersonalizedComponent,
    ],
    imports: [CommonModule, SharedModule, FormsModule, IonicModule],

    providers: [
        {
            provide: ROUTES,
            useFactory: configHomeRoutes,
            deps: [SettingsQuery],
            multi: true,
        },
    ],
    exports: [
        GenericComponent
    ]
})
export class HomeModule {}

/**
 * TODO: Ver si se puede meter todo esto directamente en el .routing
 */
export function configHomeRoutes(settingsQuery: SettingsQuery) {
    const routes: Routes = [
        {
            path: ':clinicId',
            canActivateChild: [ParentSystemkeyGuard],
            loadChildren: () =>
                import('../../modules/user-tabs/user-tabs.module').then(
                    (m) => m.UserTabsModule
                ),
        },
        {
            path: '',
            component: settingsQuery.isGeneric()
                ? GenericComponent
                : PersonalizedComponent,
        },
        {
            path: '**',
            loadChildren: () =>
                import('../not-found/not-found.module').then(
                    (m) => m.NotFoundModule
                ),
        },
    ];

    return routes;
}
